<template>
  <div :class="`t3m-ImageMap t3m-ImageMap--${status}`">
    <div class="t3m-ImageMap-hotspotMap">
      <t3m-video />
      <t3m-hotspots />
      <span class="t3m-ImageMap-back" @click="reset">Back to map</span>
    </div>
    <div class="t3m-ImageMap-hotspotList">
      <t3m-hotspot
        v-for="h in hotspots"
        :key="h.id"
        :specs="h"
        appearance="listItem"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import t3mHotspots from "@/components/t3mHotspots/";
import t3mHotspot from "@/components/t3mHotspot/";
import t3mVideo from "@/components/t3mVideo/";

export default {
  name: "App",
  components: {
    t3mVideo,
    t3mHotspots,
    t3mHotspot,
  },
  props: {
    api: String,
  },
  computed: {
    ...mapState(["hotspots", "status"]),
    getImageMapAPI() {
      return window.t3mImageMapAPI;
    },
  },
  mounted() {
    this.$store.dispatch("loadAllData", this.api);
  },
  methods: {
    ...mapActions(["reset", "setStatus"]),
  },
};
</script>
